import type { ButtonBlockConfig, ButtonBlockConfigure, OperatorButtonConfigure } from '@lighthouse/core'
import { ActionHandleEventType, ActionItemPattern, ALIGNMENT, BLOCK_SIZE, EVENT_TYPE, SHAPE } from '@lighthouse/core'
import { generateJson } from '@lighthouse/shared'
import { getRandomIcon, nanoid } from '@lighthouse/tools'

/**
 * 初始化单个按钮配置
 *
 * @param {?ActionItemPattern} [pattern]
 * @returns {ButtonBlockConfigure}
 */
export const getInitButton = function (pattern?: ActionItemPattern): ButtonBlockConfigure {
    return {
        size: BLOCK_SIZE.md,

        shape: SHAPE.rectangle,

        radius: '8',

        align: ALIGNMENT.left,

        iconPosition: 'left',

        showType: 'icon-name',

        pattern: pattern ?? ActionItemPattern.primary,

        backgroundColor: { type: 'color', color: '#12B76A' },

        color: { type: 'color', color: '#fff' },

        name: generateJson('按钮'),

        icon: getRandomIcon(),

        collectEvents: []
    }
}

export const getInitOperatorButton = function (pattern?: ActionItemPattern): OperatorButtonConfigure {
    const config = getInitButton(pattern)
    return {
        id: nanoid(),
        fillWay: 'contain',
        ...config
    }
}

/**
 * 生成按钮block的配置
 *
 * @returns {ButtonBlockConfig}
 */
export const generateButtonBlock = (mainBreakPoint: string): ButtonBlockConfig => {
    return {
        ...getInitButton(ActionItemPattern.primary),
        eventList: [
            {
                id: nanoid(),
                type: EVENT_TYPE.CLICK,
                config: {},
                actions: [
                    {
                        id: nanoid(),
                        type: ActionHandleEventType.NOTIFICATION,
                        data: {
                            notification: {
                                notificationStatus: 'INFO',
                                notificationContent: {
                                    type: 'doc',
                                    content: [
                                        {
                                            type: 'paragraph',
                                            content: [
                                                {
                                                    type: 'text',
                                                    text: '请配置按钮点击后执行的动作'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                ]
            }
        ],

        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            }
        },
        breakPoints: []
    }
}
